import { listItem } from './ListItem.css';
import type { PostListItemProps } from './ListItem.types';

export const PostListItem = ({
  element,
  children,
  // we don't want these extra props in the ...props rest since we're spreading it on a div
  isLive,
  isIndexingDisabled,
  rewriteImageSrc,
  homePath,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  ...props
}: PostListItemProps) => {
  /* spreading props on standard DOM elements causes React warnings and hydration errors */
  return (
    <li {...props} className={listItem}>
      {children}
    </li>
  );
};
